import axios from "axios";
import Auth from "./auth";
import Utility from "../components/modal";
import { ACCESS_TOKEN } from "../common/const";

function parseJSON(response) {
  return response.json ? response.json() : response;
}

/**
 * Checks if a network request came back fine, and throws an error if not
 *
 * @param  {object} response   A response from a network request
 *
 * @return {object|undefined} Returns either the response, or throws an error
 */
function checkStatus(response) {
  if (!!response.headers.token) {
    Auth.set("token", response.headers.token);
    return response;
  }
  if (response.status >= 200 && response.status < 300) {
    if (
      response.data &&
      response.data.success === false &&
      response.data.msg &&
      response.data.msg.toLowerCase() === "invalid token"
    ) {
      Utility.showAlert("Your login session expired. Please login again.");
      Auth.clearAppStorage();
      window.location.reload();
    }
    return response;
  }

  return parseJSON(response).then((responseFormatted) => {
    const error = new Error(response.statusText);
    error.response = response;
    error.response.payload = responseFormatted;
    throw error;
  });
}

const ServiceRequest = async (method, responseType, url, data) => {
  try {
    let options = {};
    options.headers = Object.assign({
      [ACCESS_TOKEN]: Auth.get("token"),
      url: url,
      method: method,
      data: data,
      responseType: responseType,
    });
    axios.defaults.headers.token = Auth.get("token");

    return await axios(options.headers)
      .then(checkStatus)
      .then(parseJSON)
      .catch((error) => {
        if (error.response) {
          let res = error.response;
          if (res.status === 403) {
            window.location.reload();
          } else if (res.status === 500) {
            Utility.showAlert("Error occured. Please try after sometime");
          }
        } else if (error.request) {
        } else {
        }

        throw error;
      });
  } catch (err) {
    throw err;
  }
};
export default ServiceRequest;
